import cache from './cache';
import cloneSvg from './clone-svg';
import makeAjaxRequest from './make-ajax-request';
import { processRequestQueue, queueRequest } from './request-queue';
var loadSvgCached = function (url, httpRequestWithCredentials, callback) {
    if (cache.has(url)) {
        var cacheValue = cache.get(url);
        if (cacheValue === undefined) {
            queueRequest(url, callback);
            return;
        }
        if (cacheValue instanceof SVGSVGElement) {
            callback(null, cloneSvg(cacheValue));
            return;
        }
    }
    cache.set(url, undefined);
    queueRequest(url, callback);
    makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
        if (error) {
            cache.set(url, error);
        }
        else if (httpRequest.responseXML instanceof Document &&
            httpRequest.responseXML.documentElement &&
            httpRequest.responseXML.documentElement instanceof SVGSVGElement) {
            cache.set(url, httpRequest.responseXML.documentElement);
        }
        processRequestQueue(url);
    });
};
export default loadSvgCached;
//# sourceMappingURL=load-svg-cached.js.map